var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDomain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u4F01\u4E1A icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-28.3%",
    y: "-21.7%",
    width: "156.7%",
    height: "156.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.694035823   0 0 0 0 0.78947419   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49A0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2367FD",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-\\u4E3B\\u754C\\u9762-2",
    transform: "translate(-437, -435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F53\\u524D\\u4F01\\u4E1A",
    transform: "translate(120, 110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main",
    transform: "translate(30, 298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6478\\u4E0A\\u53BB\\u6548\\u679C",
    transform: "translate(272, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4F01\\u4E1A-icon",
    filter: "url(#filter-1)",
    transform: "translate(20, 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "url(#linearGradient-2)",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6818145,20.6666517 L21.045457,20.6666517 L21.045457,12.6666619 C21.045457,11.9333289 20.4727285,11.3333279 19.7727285,11.3333279 L17.2272715,11.3333279 L17.2272715,20.6666517 L16.5909141,20.6666517 L16.5909141,9.33333402 C16.5909141,8.60000102 16.0181855,8 15.3181855,8 L10.2272715,8 C9.52727148,8 8.95455664,8.5999867 8.95455664,9.33331969 L8.95455664,20.6666517 L8.31817188,20.6666517 C8.12727148,20.6666517 8,20.799998 8,21 L8,21.6666772 C8,21.866668 8.12728516,22 8.31818555,22 L21.6818145,22 C21.8727285,22 22,21.866668 22,21.6666772 L22,21 C22,20.799998 21.8727148,20.666666 21.6818145,20.666666 L21.6818145,20.6666517 Z M12.1363574,17.6666639 C12.1363574,17.8666517 12.0090859,17.999998 11.8181855,17.999998 L10.545457,17.999998 C10.354543,17.999998 10.2272715,17.8666517 10.2272715,17.6666639 L10.2272715,16.9999867 C10.2272715,16.7999959 10.3545566,16.6666639 10.545457,16.6666639 L11.8181719,16.6666639 C12.0090859,16.6666639 12.1363574,16.7999959 12.1363574,16.9999867 L12.1363574,17.6666639 L12.1363574,17.6666639 Z M12.1363574,14.9999959 C12.1363574,15.199998 12.0090859,15.3333299 11.8181855,15.3333299 L10.545457,15.3333299 C10.354543,15.3333299 10.2272715,15.1999836 10.2272715,14.9999959 L10.2272715,14.333333 C10.2272715,14.1333279 10.3545566,13.9999959 10.545457,13.9999959 L11.8181719,13.9999959 C12.0090859,13.9999959 12.1363574,14.1333279 12.1363574,14.333333 L12.1363574,14.9999959 L12.1363574,14.9999959 Z M12.1363574,12.3333279 C12.1363574,12.5333299 12.0090859,12.6666619 11.8181855,12.6666619 L10.545457,12.6666619 C10.354543,12.6666619 10.2272715,12.5333156 10.2272715,12.3333279 L10.2272715,11.666665 C10.2272715,11.4666598 10.3545566,11.3333279 10.545457,11.3333279 L11.8181719,11.3333279 C12.0090859,11.3333279 12.1363574,11.4666742 12.1363574,11.666665 L12.1363574,12.3333279 L12.1363574,12.3333279 Z M15.3181855,17.6666639 C15.3181855,17.8666517 15.1909004,17.999998 15,17.999998 L13.7272852,17.999998 C13.5363574,17.999998 13.4090859,17.8666517 13.4090859,17.6666639 L13.4090859,16.9999867 C13.4090859,16.7999959 13.5363711,16.6666639 13.7272715,16.6666639 L15,16.6666639 C15.1909141,16.6666639 15.3181855,16.7999959 15.3181855,16.9999867 L15.3181855,17.6666639 Z M15.3181855,14.9999959 C15.3181855,15.199998 15.1909004,15.3333299 15,15.3333299 L13.7272852,15.3333299 C13.5363574,15.3333299 13.4090859,15.1999836 13.4090859,14.9999959 L13.4090859,14.333333 C13.4090859,14.1333279 13.5363711,13.9999959 13.7272715,13.9999959 L15,13.9999959 C15.1909141,13.9999959 15.3181855,14.1333279 15.3181855,14.333333 L15.3181855,14.9999959 Z M15.3181855,12.3333279 C15.3181855,12.5333299 15.1909004,12.6666619 15,12.6666619 L13.7272852,12.6666619 C13.5363574,12.6666619 13.4090859,12.5333156 13.4090859,12.3333279 L13.4090859,11.666665 C13.4090859,11.4666598 13.5363711,11.3333279 13.7272715,11.3333279 L15,11.3333279 C15.1909141,11.3333279 15.3181855,11.4666742 15.3181855,11.666665 L15.3181855,12.3333279 Z M20.0909141,17.6666639 C20.0909141,17.8666517 19.9636426,17.999998 19.7727285,17.999998 L18.5,17.999998 C18.3090859,17.999998 18.1818145,17.8666517 18.1818145,17.6666639 L18.1818145,16.9999867 C18.1818145,16.7999959 18.3090996,16.6666639 18.5,16.6666639 L19.7727148,16.6666639 C19.9636426,16.6666639 20.0909141,16.7999959 20.0909141,16.9999867 L20.0909141,17.6666639 L20.0909141,17.6666639 Z M20.0909141,14.9999959 C20.0909141,15.199998 19.9636426,15.3333299 19.7727285,15.3333299 L18.5,15.3333299 C18.3090859,15.3333299 18.1818145,15.1999836 18.1818145,14.9999959 L18.1818145,14.333333 C18.1818145,14.1333279 18.3090996,13.9999959 18.5,13.9999959 L19.7727148,13.9999959 C19.9636426,13.9999959 20.0909141,14.1333279 20.0909141,14.333333 L20.0909141,14.9999959 L20.0909141,14.9999959 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain);
export default __webpack_public_path__ + "static/media/domain.c989a91ed964f44ab3d27d50f21138b3.svg";
export { ForwardRef as ReactComponent };